<template>
  <div ref="mainWrapper" class="lxn-h100 lxn-w100 lxn-pos-rel">
    <CustomCurve v-if="!hideCurve">
      <div class="CurveWithSvg-default-slot-wrapper lxn-w100 lxn-pos-rel">
        <slot name="default"></slot>
      </div>
    </CustomCurve>
    <div :style="svgHeight" class="CurveWithSvg-wrapper-svg lxn-w100 lxn-pos-abs">
      <slot name="svg"></slot>
    </div>
  </div>
</template>

<script>
import CustomCurve from '@/components/CustomCurve.vue'

export default {
  name: 'CurveWithSvg',
  components: {
    CustomCurve
  },
  props: {
    hideCurve: Boolean,
  },
  data: function () {
    return {
      window: {
        componentWidth: 0,
        height: 0,
        componentHeight: 0
      }
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function () {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    svgHeight: function () {
      var svgHeight = this.window.componentWidth < this.window.componentHeight ? this.window.componentWidth : this.window.componentHeight;
      var svgMarginTop = this.window.componentWidth < this.window.componentHeight ? this.window.componentHeight - this.window.componentWidth : 0;
      svgMarginTop = Math.floor(svgMarginTop / 2);
      var style = "height: " + svgHeight + "px;";
      style += "margin-top: " + svgMarginTop + "px;";
      return style;
    }
  },
  methods: {
    handleResize: function () {
      this.window.componentWidth = this.$refs.mainWrapper.clientWidth;
      this.window.height = window.innerHeight;
      this.window.componentHeight = this.$refs.mainWrapper.clientHeight;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .CurveWithSvg-wrapper-svg {
    top: 0;
    left: 0;
    z-index: 1;
    padding: 10px;
  }
  .CurveWithSvg-default-slot-wrapper {
    z-index: 2;
  }
</style>
